import { useTranslation } from 'react-i18next';
import { Badge } from '@xxtract/ui';

/** h5-8 FR38a: a neutral (not success/warning/error) chip — an existing product is neither good nor bad news. */
export function ChangeChip() {
  const { t } = useTranslation();
  return (
    <Badge variant="secondary" data-testid="intake-change-chip">
      {t('intake.review.changes.chipLabel')}
    </Badge>
  );
}
